'use strict';

module.exports = ['$scope', '$rootScope', '$controller', '$location', '$window', '$interval', 'OrderSvc', 'MaterialSvc', 'MixDesignSvc', function ($scope, $rootScope, $controller, $location, $window, $interval, OrderSvc, MaterialSvc, MixDesignSvc) {
    $controller('PDCalendarCtrl', {$scope: $scope});

    $scope.ordersEmpty = function () {
        // TODO this should be refactored to a server side call
        if (!$scope.month) {
            return true;
        }
        for (var week_id in $scope.month.weeks) {
            for (var weekday_id in $scope.month.weeks[week_id].weekdays) {
                if ($scope.month.weeks[week_id].weekdays[weekday_id].total_dayshift || $scope.month.weeks[week_id].weekdays[weekday_id].total_nightshift) {
                    return false;
                }
            }
        }
        return true;
    };

    $scope.pillWidth = function (input) {
        // Calculates the width of the pills in the calendar day view, based
        // on the order size
        var n = Math.abs(input);
        var max = $scope.$root.isMobile ? 20 : 90;  //maximum number of allowable pixels in a "pill"
        var mid_point = (0.4) * $scope.plantObj.max_capacity; // 40% of Plant max //quantity of an order that will be shown as 1/2 max segments in a "pill"
        var min = 3;  //minimum allowable pixels in a pill

        var x = (2 * max / Math.PI) * Math.atan(n / mid_point) + min;

        return x;
    };

    $scope.refreshDataClick = function () {
        $rootScope.$broadcast('refresh-signal');
    };

    // ------------------
    // EVENTS
    // ------------------
    $scope.$on('refresh-signal', function () {
        refreshData();
    });

    // ------------------
    // Helpers
    // ------------------
    function refreshData() {
        $scope.loadMonth($scope.selectedYear, $scope.selectedMonth);
    }

    // ------------------
    // Initialization
    // ------------------
    $scope.dataSvc = OrderSvc;
}];
